import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { makeChats } from "./slices/chats";
import { makeMe } from "./slices/me";
import { makeTasks } from "./slices/tasks";

const createAppStore = () => {
    const me = makeMe();
    const chats = makeChats();
    const tasks = makeTasks();

    return { me, chats, tasks };
};

export const store = createAppStore();

const context = createContext<typeof store | null>(null);

export const AppProvider = context.Provider;

export const useApp = () => {
    const state = useContext(context);

    if (!state) {
        throw new Error("There's no Provider for App Context");
    }

    return state;
};

export const getMe = () => store.me;

export const getChats = () => store.chats;
